module.exports = __webpack_public_path__ + "img/filter-error.0ae03dcd.png";